import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <svg className="loader-circle" viewBox="0 0 100 100">
        <defs>
          <linearGradient id="loaderGradient" gradientTransform="rotate(90)">
            <stop offset="0%" stopColor="#EAC94F" />
            <stop offset="100%" stopColor="#40BBD2" />
          </linearGradient>
        </defs>

        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="url(#loaderGradient)"
          strokeWidth="6"
        />
      </svg>
    </div>
  );
};

export default Loader;
